import * as React from 'react';
import {
  Box,
  Color,
  Display,
  FlexDirection,
  Icon,
  IconVariant,
  withCitrusTheme,
} from '@gousto-internal/citrus-react';

const FeatureListUL = withCitrusTheme('ul', (theme) => [
  {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: Display.Flex,
    flexDirection: FlexDirection.Column,
  },
  theme.responsiveSpacing(2, ['gap']),
]);

type FeatureListProps = {
  children: React.ReactNode;
  iconVariant?: IconVariant;
  name: string;
};

export function FeatureList(props: FeatureListProps) {
  const { iconVariant = IconVariant.Inherit, children } = props;
  const childrenArray = React.Children.toArray(children);

  return (
    <FeatureListUL>
      {childrenArray.map((child, idx) => (
        <li key={`${props.name}-${idx}`}>
          <Box display={Display.Flex} gap={1}>
            <Box color={Color.Success_400}>
              <Icon variant={iconVariant} name="tick" />
            </Box>
            {child}
          </Box>
        </li>
      ))}
    </FeatureListUL>
  );
}
